define('auth/email',['jquery', 'plugins/http', 'knockout', 'durandal/app', 'plugins/router'], function ($, http, ko, app, router) {
   
    var viewmodel = function () {
        var self = this;

        self.email = ko.observable();
        self.password = ko.observable();
        self.errormessage = ko.observable();

        self.router = router;
        
        self.activate = function () {
          
        };
        self.loginCommand = function () {
            self.login()
                .then(self.processlogin);
        };

        self.processlogin = function (response) {
            // check response and display error or redirect as sucessfull
            if (!response.success) {
                self.errormessage(response.error);
            }
            else {
                router.navigate('/');
                location.reload("/");
            }
        };


        self.login = function () {
            var url = '/api/auth/login',
                data = {
                    email: self.email,
                    password: self.password
                };

            return http.post(url, data);
        };
    };

    return viewmodel;
});

